var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"pub_date",domProps:{"innerHTML":_vm._s(_vm.show_pub_date)}})])}
var staticRenderFns = []

export { render, staticRenderFns }